import React from 'react';
import { Shield, Clock, Target, Euro, Headset, CheckCircle } from 'lucide-react';
import { features } from '../data/mock';
import { Stagger, Item, SectionHeading } from './Reveal';
import CountUp from './CountUp';

const icons = { shield: Shield, clock: Clock, target: Target, euro: Euro, headset: Headset, check: CheckCircle };

const FeaturesSection = () => (
  <section id="features" className="relative bg-obsidian text-white py-24 lg:py-32 overflow-hidden grain" data-testid="features-section">
    <div className="absolute inset-0 mesh-grid opacity-60" />
    <div className="absolute -top-32 right-1/4 w-[600px] h-[600px] rounded-full bg-violet-700/25 blur-[140px] light-pool" />
    <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-amber-400/50 to-transparent" />

    <div className="relative z-10 max-w-7xl mx-auto px-5 lg:px-8">
      <SectionHeading
        dark
        eyebrow="Warum HIREKA"
        title={<>Kein Prozentsatz. Kein Risiko. <span className="text-gold">Kandidat in 24h.</span></>}
        subtitle="Sechs Gründe, warum über 200 Unternehmen ihre Positionen nicht mehr klassisch besetzen."
      />

      <Stagger className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-5" stagger={0.08}>
        {features.map((f, i) => {
          const Icon = icons[f.icon];
          const large = f.size === 'large';
          return (
            <Item key={f.id} className={`lux-card-dark p-7 lg:p-8 relative overflow-hidden group ${large ? 'md:col-span-2 lg:col-span-1 lg:row-span-2 flex flex-col justify-between' : ''}`} data-testid={`feature-card-${f.id}`}>
              <div className="absolute -right-10 -top-10 w-40 h-40 rounded-full bg-violet-600/20 blur-3xl group-hover:bg-amber-400/15 transition-colors duration-500" />
              <div className="relative">
                <div className="flex items-center justify-between mb-6">
                  <div className="w-12 h-12 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center group-hover:border-amber-400/40 transition-colors">
                    <Icon className="w-5 h-5 text-amber-400" />
                  </div>
                  <span className="text-xs font-bold tracking-[0.18em] uppercase text-slate-500">{f.badge}</span>
                </div>
                {large && (
                  <div className="font-display text-7xl lg:text-8xl font-extrabold text-gold leading-none mb-6">
                    <CountUp to={24} suffix="h" duration={1400} />
                  </div>
                )}
                <h3 className="text-xl font-bold text-white leading-snug">{f.title}</h3>
                <p className="mt-3 text-slate-400 leading-relaxed text-sm md:text-base">{f.description}</p>
              </div>
              {large && (
                <div className="relative mt-10 pt-6 border-t border-white/10 text-sm text-slate-400">
                  Durchschnittliche Lieferzeit unserer letzten 50 Besetzungen: <span className="text-white font-semibold">21h 48min</span>
                </div>
              )}
            </Item>
          );
        })}
      </Stagger>
    </div>
  </section>
);

export default FeaturesSection;
